import { en } from "./en";

type LocaleOverrides = {
  header?: Partial<typeof en.header>;
  steps?: Partial<typeof en.steps>;
  upload?: Partial<typeof en.upload>;
  languages?: Partial<typeof en.languages>;
  conversion?: Partial<typeof en.conversion>;
  nav?: Partial<typeof en.nav>;
  footer?: Partial<typeof en.footer>;
  languageOptions?: Partial<typeof en.languageOptions>;
};

export function createLocale(overrides: LocaleOverrides = {}) {
  return {
    ...en,
    header: {
      ...en.header,
      ...(overrides.header || {}),
    },
    steps: {
      ...en.steps,
      ...(overrides.steps || {}),
    },
    upload: {
      ...en.upload,
      ...(overrides.upload || {}),
    },
    languages: {
      ...en.languages,
      ...(overrides.languages || {}),
    },
    conversion: {
      ...en.conversion,
      ...(overrides.conversion || {}),
    },
    nav: {
      ...en.nav,
      ...(overrides.nav || {}),
    },
    footer: {
      ...en.footer,
      ...(overrides.footer || {}),
    },
    languageOptions: {
      ...en.languageOptions,
      ...(overrides.languageOptions || {}),
    },
  };
}
